<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/rebate',title:'信贷管理'},{title:'国内应收逾期账龄日报表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox zhi">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="售达方名称">
							    <el-input v-model="formInline.soldToName" placeholder=""></el-input>
							</el-form-item>
							<el-form-item label="是否销售组织"  >
								<el-switch
										v-model="formInline.isGscode"
										active-text="是"
										inactive-text="否">
								</el-switch>
							</el-form-item>
							<el-form-item label="创建日期">
								<el-date-picker
										v-model="formInline.createDate"
										type="date"
										value-format="yyyy-MM-dd"
										placeholder="选择日期">
								</el-date-picker>
							</el-form-item>
							<!--<el-form-item label="币种">-->
								<!--<el-input v-model="formInline.currencyCode" placeholder=""></el-input>-->
							<!--</el-form-item>-->
						</div>
                       <!-- <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="selectData">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resectData">重置
                            </el-button>
                        </div> -->
                    </el-form>
					<div class="l-screenBox">
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="selectData">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resectData">重置
							</el-button>
						</div>
					</div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <div style="background:#fff;width:100%;">
                        <el-table
                                ref="multipleTable"
                                :data="tableData2"
								border
                                style="width: 100%"
								max-height="460"
                        >
							<!--<el-table-column-->
								<!--type="selection"-->
								<!--width="40"-->
								<!--label="全选">-->
							<!--</el-table-column>-->
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#"
                                    fixed>
                            </el-table-column>
							<el-table-column
									prop="cdate"
									label="创建日期"
									:formatter="formatDate"
									width="120">
							</el-table-column>
                            <el-table-column
                                    prop="soldToCode"
                                    label="售达方编码"
                                    width="120">
                            </el-table-column>
							<el-table-column
									prop="soldToName"
									label="售达方名称"
									width="120">
							</el-table-column>
							<el-table-column
									v-if="isGscode"
									prop="gscode"
									label="销售组织"
									width="120">
							</el-table-column>
							<el-table-column
									prop="currencyCode"
									label="币种"
									width="120">
							</el-table-column>
							<el-table-column
									prop="sumYs"
									label="应收金额"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYs1"
									label="应收一月之内"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYs2"
									label="应收1-2月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYs3"
									label="应收2-3月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYs4"
									label="应收3-4月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYs5"
									label="应收4-6月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYs6"
									label="应收6-12月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYs7"
									label="应收12-15月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYs8"
									label="应收15-18月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYs9"
									label="应收18-24月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYs10"
									label="应收2年以上"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYs11"
									label="应收3年以上"
									width="120">
							</el-table-column>
							<el-table-column
									prop="sumYq"
									label="逾期金额"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYq1"
									label="逾期1月之内"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYq2"
									label="逾期1-2月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYq3"
									label="逾期2-3月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYq4"
									label="逾期3-4月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYq5"
									label="逾期4-6月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYq6"
									label="逾期6-12月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYq7"
									label="逾期12-15月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYq8"
									label="逾期15-18月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYq9"
									label="逾期18-24月"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYq10"
									label="逾期2年以上"
									width="120">
							</el-table-column>
							<el-table-column
									prop="webtrYq11"
									label="逾期3年以上"
									width="120">
							</el-table-column>
                        </el-table>
                    </div>

                    <div class="h-tableB h-mrt30">
                        <!--<div class="h-tableBL">-->
								<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="downloadExcel">批量导出</el-button>
                        <!--</div>-->
                        <div class="h-pagination2">
                            <pagination :page="q" @query="selectDataPage"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import customerLedgerService from "../../../api/loud/credit/customerLedgerService";
    import util from "../../../utils/util";
    import updownfile from "../../../utils/updownfile";

    export default {
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),

				moreCondition: false,
                userInfoCreditVo:{
                    multipleSelection: [],
                },
				showFujianD:false,
				value1:'',
                value2: '',
                value3: 36,
                names: '',
                input1: '',
                sele: '工程',
                allFlag:false,
                isGscode:false,
                formInline: {
                    isGscode:false,
                    createDate: this.getNow(),
                    allFlag:false,
                    soldToName:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0
                },
                q:{
                    pageSize: 10,
                    pageNo: 1,
                    total: 0
                },
                multipleSelection: [],
                tableData2: [],
            }
        },
        created() {

        },
        methods: {

            tableRowClassName({row, rowIndex}) {
                let date = new Date();
                if(row.validitydate){
                    if(row.ye>0 && date>=new Date(row.validitydate.substring(0,10))){
                        return 'warning-row';
                    }
                }
                return '';
            },
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
			downloadExcel(){
				//ids
				var cc = [];
				for (var d in this.tableData2.id) {
					cc.push(this.tableData2[d].id);
				}
				//查询参数
				var c = {
					ids: cc,
				};
				console.log("c====",c);
				console.log(this.formInline,'!!!!!!!!!!')
				updownfile.down("/api/swyl/v1/infoCredit/OrderMoneyBackWxWkpFp/downloadFileNxDayExcel", this.formInline, 'post');
				console.log("执行完了")
			},
            timeSelect() {
                this.formInline.sptgTime = this.value2[0];
                this.formInline.sptgTime1 = this.value2[1];
            },
			timeSelect1() {
				this.formInline.add5 = this.value1[0];
				this.formInline.add5I = this.value1[1];
			},
            //检索按钮功能
            selectData() {
                this.q.pageNo = 1;
                this.selectDataPage();
            },
            selectDataPage() {
                this.q.soldToName = this.formInline.soldToName;
                this.q.allFlag = this.formInline.allFlag;
                this.allFlag = this.formInline.allFlag;
                this.q.isGscode = this.formInline.isGscode;
                this.isGscode = this.formInline.isGscode;
                this.q.createDate = this.formInline.createDate;
                customerLedgerService.queryYsSelectNxDayPage(this.q).then(response => {
                     this.tableData2 = response.records;
                    this.q.total = response.total;
                })
            },
			chooseModify() {
				if (this.moreCondition) {
					this.moreCondition = false;
				} else {
					this.moreCondition = true;
				}
			},
            //重置按钮功能
            resectData() {
                this.formInline.isGscode = false;
                this.formInline.allFlag = false;
                this.formInline.soldToName = null;
            },
            handleSelectionChange(val) {
                console.log(val,'val')
                this.multipleSelection = val;
            },
            handleSizeChange() {
                console.log(1)
            },
			seeFile(o){
				this.refid = this.ddhU = o.sapCode;
				this.showFujianD = true;
			},
            handleCurrentChange() {
                console.log(2)
            },
            handleScroll(e) {
                console.log(e.target.scrollLeft)
            },
			getNow(){
				let date = new Date();

				return this.$util.riQi3(date);
			},
			formatDate(row, column) {
				// 获取单元格数据
				let data = row[column.property]
				if(data == null || data == '') {
					return null
				}
				let dt = new Date(data)
				return this.$util.riQi3(dt);
			},
        },
        mounted() {
            //查询所有信贷列表
            this.selectDataPage();
        }
    }
</script>
<style>
    .el-table .warning-row {
        background: #ffd200;
        color:red;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
    .zhi .h-formBorder .el-form-item__label {
        vertical-align: top;
    }

    .zhi .el-date-editor .el-range-separator {
        width: 9%;
        margin-bottom: 0;
    }

</style>
